import { jsx as _jsx } from "react/jsx-runtime";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import termsOfService from "@faire/web-api--source/routes/tos";
import * as React from "react";
export var termsOfServiceLinkFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(EmbeddedLink, {
        linkTo: termsOfService(),
        target: "_blank",
        children: chunks
    });
};
